import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/geometric-mean-return-calculator',
  component: () => import('../../routes/GeometricMeanReturnCalculator.svelte'),
  card: {
    id: 'geometric-mean-return-calculator',
    title: 'Geometric Mean Return',
    description:
      'Calculate the geometric mean return of a series of period returns. The correct method for averaging multi-period investment returns, unlike simple arithmetic averaging.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/geometric-mean-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Geometric Mean Return Calculator – Average Multi-Period Returns Correctly',
    description:
      'Free geometric mean return calculator. Accurately average investment returns across multiple periods using compound growth method. Compare with arithmetic mean and see risk-adjusted return.',
  },
};

export default meta;